// IMPORT CSS
import '../../sass/pages/_landing.scss'

// IMPORT LIBRARIES
import "lazysizes";

// IMPORT CUSTOM LIBRARIES
import Modal from "../components/modal";
import AnchorButtons from "../components/anchorButtons";
import TriggerAnimation from '../components/triggerAnimation';
import SplitText from '../components/splitText';
import '../components/seeker';

// IMPORT SWIPERS
import { loadSwipers } from "../components/customSwipers";

(function page() {
	let loader = document.querySelector('.loader')
	let domElements = setInitialState()

	loadSwipers()
	new AnchorButtons('#AnchorButtons', { anchorItemClass: 'cp-anchors__item' })
	new Modal('#ModalVideo', { activators: '.cp-video-preview', iframeWrapper: 'iframeWrapper' })

	intersectionAnchor()

	if (loader) return loader.addEventListener('onHide', () => loadAnimation(domElements))
	loadAnimation(domElements)
})()

// ESTABLECE Y CARGA LAS ANIMACIONES
function setInitialState() {
	// TITLES
	let splitTitles = new SplitText('.cp-chapters__title, .cp-chapters__article-title, .cp-cans__title, .cp-can-info__title')

	// BANNER ELEMENTS
	let bannerTitle = new SplitText('.cp-banner__title', { auto: false })
	let bannerDescVideo = new TriggerAnimation('.cp-banner__desc, .cp-banner__video', {
		mobile: {
			to: { delay: 0.5, stagger: 0.2, scrollTrigger: { trigger: '.cp-banner__title' } }
		},
		desktop: {
			to: { delay: 0.8, stagger: 0.3, scrollTrigger: { trigger: '.cp-banner__title' } }
		}
	})
	let bannerScroll = new TriggerAnimation('.cp-banner__more', {
		mobile: {
			from: { opacity: 0 }, to: { delay: 1.5 }
		}
	})
	let anchorButtons = new TriggerAnimation('.cp-anchors__item', {
		mobile: {
			from: { translateX: -50, opacity: 0 },
			to: { translateX: 0, duration: 0.5, delay: 1.2, stagger: 0.2, scrollTrigger: { trigger: '.cp-anchors' } }
		},
		desktop: {
			from: { translateX: -50, opacity: 0 },
			to: { translateX: 0, delay: 1.2, stagger: 0.2, scrollTrigger: { trigger: '.cp-anchors' } }
		}
	})

	// TOUR SECTION ELEMENTS
	let mapImages = new TriggerAnimation('.cp-chapters__map-image, .cp-chapters__chef-photo', {
		mobile: {
			from: { opacity: 0 },
			to: { stagger: 0.5, scrollTrigger: { trigger: '.cp-chapters__chef' } }
		}
	})
	let chefName = new TriggerAnimation('.cp-chapters__chef-name', {
		mobile: {
			from: { opacity: 0 }
		}
	})
	let tourDescVideo = new TriggerAnimation('.cp-chapters__video-source, .cp-chapters__list, .cp-chapters__btn')
	let tourNavigation = new TriggerAnimation('.tour-group-buttons, .tour-swiper-message', {
		desktop: {
			from: { opacity: 0 }
		}
	})

	// RECIPES SECTION ELEMENTS
	let seeker = new TriggerAnimation('.cp-seeker')

	// BEER SECTION ELEMENTS
	let beerImageAndText = new TriggerAnimation('.cp-can-info__image, .cp-can-info__desc')
	let tadaButton = new TriggerAnimation('.cp-button--tada', {
		mobile: {
			from: { opacity: 0 }
		}
	})

	// SWIPER ELEMENTS
	let swiperElements = new TriggerAnimation('.swiper-pagination', {
		mobile: {
			from: { opacity: 0 },
			to: { duration: 0.5 }
		}
	})

	return [
		splitTitles, bannerTitle, bannerDescVideo, bannerScroll,
		anchorButtons, mapImages, chefName, tourDescVideo, tourNavigation,
		seeker, beerImageAndText, tadaButton, swiperElements
	]
}

function loadAnimation(elements: Array<SplitText | TriggerAnimation>) {
	elements.forEach((element: any) => element.triggerAnimation())
}

function intersectionAnchor() {
	window.addEventListener('DOMContentLoaded', () => {
		const anchorWrapper = document.querySelector('#AnchorButtons')
		const footer = document.querySelector('.site-footer')

		const observer = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
			entries.forEach((entry: IntersectionObserverEntry) => {
				if (entry.isIntersecting) anchorWrapper?.classList.add('cp-anchors--hide')
				else anchorWrapper?.classList.remove('cp-anchors--hide')
			})
		}, { threshold: 0.2 })

		footer && observer.observe(footer)
	})
}